
export const Selectors = {
  gallery: '#product-gallery',
  galleryData: '#product-gallery-data',
}
